import { api } from 'shared/api'

import { smartSegmentApiSchemas } from './schemas'

export const smartSegmentApi = {
  getList: api.account.createGet({
    url: '/smartSegment/list',
    schemas: smartSegmentApiSchemas.getList,
    scope: 'audience',
    section: 'smart_segments',
  }),
  delete: api.account.createPost({
    url: '/smartSegment/delete',
    schemas: smartSegmentApiSchemas.delete,
    scope: 'audience',
    section: 'smart_segments',
  }),
  fetch: api.account.createGet({
    url: '/smartSegment/get',
    schemas: smartSegmentApiSchemas.fetch,
    scope: 'audience',
    section: 'smart_segments',
  }),
  create: api.account.createPost({
    url: '/smartSegment/create',
    schemas: smartSegmentApiSchemas.create,
    scope: 'audience',
    section: 'smart_segments',
  }),
  rename: api.account.createPost({
    url: '/smartSegment/rename',
    schemas: smartSegmentApiSchemas.rename,
    scope: 'audience',
    section: 'smart_segments',
  }),
  updateFilter: api.account.createPost({
    url: '/smartSegment/updateFilter',
    schemas: smartSegmentApiSchemas.updateFilter,
    scope: 'audience',
    section: 'smart_segments',
  }),
  updateDescription: api.account.createPost({
    url: '/smartSegment/updateDescription',
    schemas: smartSegmentApiSchemas.updateDescription,
    scope: 'audience',
    section: 'smart_segments',
  }),
  getUsesList: api.account.createGet({
    url: '/smartSegment/getUsesList',
    schemas: smartSegmentApiSchemas.getUsesList,
    scope: 'audience',
    section: 'smart_segments',
  }),
}
